

















import {Component, Emit, Prop} from "vue-property-decorator";
import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
import AsiTextField from "@/components/common/AsiTextField";
import CompanyCreate from "@/models/company/CompanyCreate";
import {CompanyType} from "@/helpers/constants";
import AsiRadioGroup from "@/components/common/AsiRadioGroup";
import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
import {AxiosError} from "axios";

@Component({
	components: {AsiDialogFormLayout, AsiRadioGroup, AsiTextField}
})
export default class CompanyCreateDialog extends AsiDialogForm {

	@Prop({type: Boolean, default: false})
	public noRedirectOnSave!: boolean;

	protected model: CompanyCreate = new CompanyCreate();
	protected companyTypes = CompanyType;

	@Emit('save')
	public save(event: Event): Event {
		return event;
	}

	@Emit('cancel')
	public cancel(event: Event): Event {
		const form = this.$refs.form as HTMLFormElement;
		this.reset([this.model], form);
		return event;
	}

	private requestSave(event: Event): void {
		this.loading = true;
		this.$companyService.create(this.model)
			.then(res => {
				if (!this.noRedirectOnSave) {
					this.$router.push({name: 'Company', params: {id: res.id}});
				}
				this.save(event);
			})
			.catch((err: AxiosError) => {
				this.errors = err.response?.data;
			})
			.finally(() => {
				this.loading = false;
			});
	}

}
